// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { authTokenVerify,refreshToken } from "./components/redux/api/admin/authApi";

// const ProtectedRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(null); 

//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         await refreshToken();
//         const isValid = await authTokenVerify();
//         setIsAuthenticated(isValid.verify);
//       } catch (err) {
//         setIsAuthenticated(false);
//       }
//     };
//     checkAuth();
//   }, []);

//   if (isAuthenticated === null) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';
// import { isAdminAuthenticated } from '../../utils/adminAuth';
import { isAdminAuthenticated } from './components/pages/AdminPannel/utils/adminAuth';

const AdminProtectedRoute = ({ children }) => {
  // Direct check without loading state (synchronous)
  const isAuthenticated = isAdminAuthenticated();

  // If not authenticated, redirect to admin login
  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default AdminProtectedRoute;